var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 41,
    viewBox: "0 0 59 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66341 40.0002H0V16.5481L9.67287 26.2335",
    fill: "#095D7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7672 1V13.4331L19.1447 33.0906L9.66341 23.597L0 13.921V1.28187H1.49978L19.0642 18.8715L36.9031 1H38.7672Z",
    fill: "#14967F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8608 12.1469C41.9892 12.2464 43.0112 12.5851 43.9124 13.1962C44.9675 13.9116 45.7789 14.904 46.3419 16.1736L59.0001 16.3063C58.4892 13.2673 57.427 10.6049 55.809 8.30968C54.1909 6.01919 52.0832 4.23559 49.481 2.96361C46.9475 1.72481 44.0733 1.07579 40.8608 1.01184V12.1469Z",
    fill: "#095D7E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7613 27.8749C42.6897 28.5665 41.4691 28.9076 40.0994 28.8934C38.0792 28.8721 36.4919 28.0975 35.3351 26.5674C34.3416 25.2551 33.8117 23.5378 33.691 21.4629L24.0063 31.0773C25.4896 33.7515 27.5358 35.8738 30.164 37.4253C32.9956 39.0999 36.3405 39.955 40.1988 39.9953C43.5153 40.0308 46.4888 39.4387 49.1146 38.2188C51.7428 37.0013 53.8884 35.2627 55.5538 33.0054C57.2168 30.748 58.3357 28.107 58.9082 25.0798L46.2499 24.9472C45.6633 26.2073 44.8306 27.1808 43.7613 27.8749Z",
    fill: "#095D7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBase);
export default __webpack_public_path__ + "static/media/logo-base.e16d6494e803f31afb56c41231648192.svg";
export { ForwardRef as ReactComponent };